/** Utilitaires DOM. */

const ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }

/**
 * Échappe une chaîne destinée à innerHTML.
 *
 * Les noms d'établissement viennent d'un fichier du MSSS, mais les notes sont
 * saisies librement : sans échappement, un « <script> » dans une note
 * s'exécuterait chez tous les collègues.
 */
export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, (c) => ENTITIES[c])
}

export const $ = (id) => document.getElementById(id)
export const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector))

export function setText(id, text) {
  const el = $(id)
  if (el) el.textContent = text
}

export function show(el, visible) {
  if (el) el.style.display = visible ? '' : 'none'
}

/** Formats québécois : « 1 250 $ », « 3 juillet 2026 ». */
const cad = new Intl.NumberFormat('fr-CA', {
  style: 'currency',
  currency: 'CAD',
  maximumFractionDigits: 0,
})

export const money = (n) => cad.format(Math.round(n || 0))

export const plural = (n, singular, pluralForm = `${singular}s`) => (n > 1 ? pluralForm : singular)

export const formatNumber = (n) => n.toLocaleString('fr-CA')

export function formatDate(iso) {
  return new Date(`${iso}T00:00:00`).toLocaleDateString('fr-CA', {
    day: 'numeric', month: 'long', year: 'numeric',
  })
}

export function formatDateTime(iso) {
  return new Date(iso).toLocaleString('fr-CA', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

/**
 * « 3 juillet », « 1er août » : date de facturation, sans l'année qui
 * n'apporte rien à si courte échéance.
 *
 * Intl rend « 1 août » ; en français, seul le premier du mois prend l'ordinal.
 */
export function formatDayMonth(date) {
  const month = date.toLocaleDateString('fr-CA', { month: 'long' })
  const day = date.getDate()
  return `${day === 1 ? '1er' : day} ${month}`
}

/** « le 1er », « le 14 » : le jour du mois où un client paie. */
export function formatOrdinalDay(day) {
  return day === 1 ? 'le 1er' : `le ${day}`
}
